import { render, staticRenderFns } from "./basket-form-cost.vue?vue&type=template&id=899f1eb8"
import script from "./basket-form-cost.vue?vue&type=script&lang=js"
export * from "./basket-form-cost.vue?vue&type=script&lang=js"
import style0 from "./basket-form-cost.vue?vue&type=style&index=0&id=899f1eb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports